<template>
  <div>
    <baseBack></baseBack>
    <div class="content" style="margin-top: 20px;">
      <el-table :data="list.data" style="width: 100%" height="600" border>
        <!-- <el-table-column fixed prop="id" label="客户编号" >
			        </el-table-column> -->
        <el-table-column prop="realname" label="驾照类型">
          <template slot-scope="scop">
            <div>{{$CarType(scop.row.carType) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="realname" label="科目">
          <template slot-scope="scop">
            <div style="margin: 0 0 4px 4px;">{{$SubjectType(scop.row.subject)}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="testPaperName" label="试题名称">
          <template slot-scope="scop">
            <div style="margin: 0 0 4px 4px;">{{scop.row.testPaperName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="useTimeStr" label="答题用时(分钟)">
          <template slot-scope="scop">
            <div>{{scop.row.useTimeStr}}</div>
          </template>
        </el-table-column>

        <el-table-column prop="grade" label="得分">
          <template slot-scope="scop">
            <div>{{scop.row.grade}}分</div>
          </template>
        </el-table-column>
		<el-table-column prop="totalNum" label="答题数量">
		  <template slot-scope="scop">
		    <div>{{scop.row.totalNum}}</div>
		  </template>
		</el-table-column>

        <el-table-column prop="createTime" label="模拟时间" width="200">
          <template slot-scope="scop">
            <div>{{scop.row.createTime}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scop">
            <el-button size="mini" @click="flow(scop.row)" type="primary">
              <!-- {{status?'继续模拟':'错题练习'}} -->
              错题练习
            </el-button>
            <el-button size="mini" @click="del(scop.row)" type="danger" v-if="status">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end;margin: 20px 0;">
        <basePagination :size="list.perPage" :page="list.currentPage" :total="list.total" @SizeChange='SizeChange' @CurrentChange='CurrentChange' />
        <el-button type="primary" size="mini" :disabled="list.total == 0 ? true : false" @click="allDel" style="margin-left: 10px;">全部删除</el-button>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :show-close="false" :close-on-click-modal="false">
      <span>确定要全部删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import loader from '@/components/base/basePagination/controls.js'
export default {
  mixins: [loader],
  data() {
    return {
      dialogVisible: false,
      options: [
        {
          value: '选项1',
          label: '考题一'
        },
        {
          value: '选项2',
          label: '考题二'
        },
        {
          value: '选项3',
          label: '考题三'
        }
      ],
      value: '',
      initial: {
        geturl: '/user/examLog',
        params: {}
      },
      list: {},
      loading: true,
      status: '',
      isId: ''
    }
  },
  created() {
    if (this.$route.query.status) {
      this.status = this.$route.query.status
    }
    this.jiazai()
  },
  methods: {
    handleClose() {
      this.axios
        .post('/user/clearLog', {
          id: 0,
          type: 1
        })
        .then(res => {
          this.jiazai()
          this.dialogVisible = false
        })
        .catch(error => {})
    },
    // 全部删除
    allDel() {
      this.dialogVisible = true
      // this.axios
      //   .post('/user/clearLog', {
      //     id: 0,
      //     type: 1
      //   })
      //   .then(res => {
      //     this.jiazai()
      //     this.dialogVisible = false
      //   })
      //   .catch(error => {})
    },
    del(e) {
      this.axios
        .post('/user/clearLog', {
          id: e.id,
          type: 1
          // mistake: 1
        })
        .then(res => {
          this.jiazai()
        })
        .catch(error => {})
    },
    flow(e) {
      if (!this.status) {
        this.$Go('case', {
          txt: '模拟考试',
          car: this.$CarType(e.carType),
          carId: e.carType,
          subject: this.$SubjectType(e.subject),
          subjectId: e.subject
        })
      } else {
        if(e.mistakeNum<=0){
          this.$message({
            type: 'success',
            message: '暂无错题!'
          });
          return
        }
        this.$Go('case', {
          txt: '错题库',
          id: e.id
        })
      }
    },

    jiazai() {
      this.getData(this.initial.params)
        .then(res => {
          this.list = res
          this.loading = false
        })
        .catch(err => {})
    }
  }
}
</script>

<style>
.el-table .cell {
  padding-left: 7px;
  display: flex;
  justify-content: space-around;
}
.el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}

.el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ebeef5;
  text-align: center;
}

.el-dialog__body {
    padding: 30px 20px;
    color: #606266;
    font-size: 22px;
    word-break: break-all;
}
.content {
    width: 1200px;
    /* margin-left: 350px; */
    margin: auto;
}

.el-popup-parent--hidden {
    overflow: hidden;
    padding-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/recode/index.vue